<script>
  import formatMoney from '../utils/currency.js';
  export let product;
  let notesArray;

  const fragranceNotes = product.node.tags.filter(tag => tag.includes('fragrance_notes'));

  if(fragranceNotes.length > 0){
    const [key, value] = fragranceNotes[0].split(':');
    notesArray = value.split('|');
  }
</script>

<a href={`/products/${product.node.handle}`} class="swiper-slide" aria-label="{product.node.title}" data-product-handle="{product.node.handle}">
  <div class="aspect-w-1 aspect-h-1 mb-2 bg-brand-lightgrey flex items-center justify-center">
    <img srcset="{`${product.node.featuredImage.url}height=500&width=500`}" width="500" height="500" loading="lazy" class="swiper-lazy" alt="{product.node.title}">
  </div>
  <div class="lg:min-h-[80px]">
    <p class="h5 mb-[6px] md:mb-1">{product.node.title}</p>
    {#if fragranceNotes.length > 0}
      <ul class="flex flex-wrap items-start mb-[2px] min-h-[20px] md:min-h-[40px] 2xl:min-h-0 md:mb-0 2xl:mb-1">
        {#each notesArray as note, i}
          <li class="font-heading text-t-small-mobile italic uppercase flex items-center !leading-none">
            <span>{note}</span>
            {#if i !== notesArray.length - 1}
              <span class=" bg-black h-0.3 w-0.3 block rounded-full mx-0.5"></span>
            {/if}
          </li>
        {/each}
      </ul>
    {/if}
  </div>

  <div class="flex mb-[25px]">
    <p class="font-regular"><span>{product.node.options[0].values[0]}</span> - <span>{formatMoney(product.node.priceRange.maxVariantPrice.amount * 100)}</span></p>
  </div>

  <a href={`/products/${product .node.handle}`} class="btn btn-transparent-black" aria-label="View Product">
    View Product
  </a>
</a>
